/** Returns the read-only status of the ontology */
export function isReadOnlyOntology(docInfo?: Pick<DocInfo, 'readOnly' | 'type'>): boolean {
    return !!docInfo && docInfo.type === 'ONTOLOGY' && docInfo.readOnly;
}
